import { FaCheck } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";

const DropdownItemAgendamentoRealizado = ({ notif, onClick }) => {
    const info = notif.atendimento_info;
    if (!info) return null;

    let dataFormatada = notif.data_criacao || "";
    if (dataFormatada && !dataFormatada.includes('/')) {
            try {
                dataFormatada = new Date(dataFormatada).toLocaleString("pt-BR");
            } catch (e) {}
    }

    return (
        <DropdownItemBase
            icon={<FaCheck />}
            text="text-success"
            titulo="Agendamento Realizado"
            descricao={
                <>
                    Paciente: <strong>{info.beneficiario_nome}</strong>
                </>
            }
            subDescricao={`Programa: ${info.programa_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemAgendamentoRealizado;
